/* eslint max-classes-per-file: ["error", 2] */

import { gsap } from 'gsap';
import { delay } from "../helpers/utils/delay";

class NewsItem {
    constructor(item) {
        this.item = item;
        this.marquee = item.querySelectorAll('.news-list-item__marquee-item');

        this.addEvents();
        this.initMarquee();
    }

    /**
     * 
     */
    addEvents() {
        this.item.addEventListener('mouseenter', () => {
            this.handleMouseOEnter();
        });

        this.item.addEventListener('mouseleave', () => {
            this.handleMouseLeave();
        });
    }

    /**
     * 
     */
    initMarquee() {

        this.timeline = gsap.timeline({
            repeat: -1,
        });
        this.timeline.pause();

        this.timeline.set(this.marquee, {
            x: (i, el) => -i * el.offsetWidth
        });

        this.timeline.to(this.marquee, {
            duration: 0.3,
            ease: "none",
            opacity: 1
        }, 0);

        this.timeline.to(this.marquee, {
            duration: 8,
            ease: "none",
            x: (i, el) => -(i + 1) * el.offsetWidth
        }, 0);

        this.timeline.to(this.marquee, {
            duration: 0.3,
            ease: "none",
            opacity: 0
        }, 7.7);
    }

    /**
     * 
     */
    handleMouseOEnter() {
        this.timeline.play();
    }

    /**
     * 
     */
    handleMouseLeave() {
        delay(300).then(() => {
            this.timeline.pause();
            this.timeline.seek(0);
        });
    }
}

class NewsList {
    constructor() {
        this.items = [];

        this.getElements();

        if (this.canInit()) {
            this.handleItems();
        }
    }

    /**
     * 
     */
    getElements() {
        this.items = document.querySelectorAll('.news-list-item');
    }

    /**
     * 
     */
    canInit() {
        return this.items.length > 0;
    }

    /**
     * 
     */
    handleItems() {
        this.items.forEach(item => {
            // eslint-disable-next-line no-new
            new NewsItem(item);
        });
    }
}

new NewsList(); // eslint-disable-line no-new


